import {RootDesc} from "@ui/descriptions/RootDesc";
import {RootIcon} from "@ui/icons/RootIcon";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

import styles from "./styles.module.scss";

export const BackButton = ({onClick}) => {
  const navigate = useNavigate();
  const {t} = useTranslation();

  const handleClickBtn = () => navigate(-1);

  return (
    <button
      className={styles.backBtn}
      onClick={() => (onClick ? onClick() : handleClickBtn())}
    >
      <RootIcon
        width={17}
        height={17}
        id={"arrow-back"}
      />

      <RootDesc>
        <span>{t("button.back")}</span>
      </RootDesc>
    </button>
  );
};
